







import MfaSettings from "@/shared/components/MfaSettings.vue";
import OktaFactorSettings from "@/shared/components/OktaFactorSettings.vue";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import {
  Vue,
  Component,
} from "@/shared/vuepack";

@Component({
  components: {
    MfaSettings,
    OktaFactorSettings
  }
})
export default class Security extends Vue {

  featureFlagStore = useFeatureFlagStore();
  get isOktaLoginEnabled () {
    return this.featureFlagStore.flags.hsa4475allowRolePermissions;
  }

}
